<app-unsupported-device></app-unsupported-device>
<app-orientation-warning></app-orientation-warning>
<router-outlet></router-outlet>
<app-cookie-popup></app-cookie-popup>
